import { useEffect, useState } from "react";
import { Link, useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, Menu, X } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import logo from '/src/assets/logo-axent.png'
import mobilelogo from '/src/assets/logo.png'

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const isMobile = useIsMobile();
    const [location] = useLocation();

    const toggleMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    const navLinks = [
        { name: "Home", path: "/" },
        { name: "About Us", path: "/about" },
        { name: "Contact", path: "/contact" },
        { name: "Products", path: "/services" },
        { name: "Login", path: "https://online.axentbrokers.com", external: true },
        { name: "Register", path: "https://online.axentbrokers.com/system/agent-register.aspx", external: true },
    ];

    //const serviceLinks = [
    //  { name: "Residential Property Onwers' Insurance", path: "/services#RPO" },
    //  { name: "Commercial Property Onwners' Insurance", path: "/services#CPO" },
    //  { name: "Commercial Insurance", path: "/services#commercial" }
    //];

    //const NavLink = ({ to, children, onClick }: { to: string; children: React.ReactNode; onClick?: () => void }) => {
    //    const isActive = location === to;
    //    return (
    //        <Link href={to}>
    //            <span
    //                onClick={onClick}
    //                className={`cursor-pointer relative text-neutral-800 hover:text-primary font-medium transition-colors after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-[-4px] after:left-0 after:bg-primary after:transition-all after:duration-300 ${isActive ? "text-primary after:w-full" : "hover:after:w-full"
    //                    }`}
    //            >
    //                {children}
    //            </span>
    //        </Link>
    //    );
    //};

    const NavLink = ({ to, children, onClick, external }: {
        to: string; children: React.ReactNode; onClick?: () => void; external?: boolean;}) => {
        const [location] = useLocation();
        const isActive = !external && location === to;

        const classes = `cursor-pointer relative hover:text-primary font-medium transition-colors 
    after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-[-4px] after:left-0 after:bg-primary after:transition-all after:duration-300
    ${isActive ? "text-neutral-400 after:w-full" : "text-neutral-800 hover:after:w-full"}`;

        return external ? (
            <a
                href={to}
                target="_blank"
                rel="noopener noreferrer"
                className={classes}
                onClick={onClick}
            >
                {children}
            </a>
        ) : (
            <Link href={to}>
                <span onClick={onClick} className={classes}>
                    {children}
                </span>
            </Link>
        );
    };


    return (
        <header className="bg-white shadow-sm fixed w-full top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-20">
                    <div className="flex items-center">
                        <Link href="/">
                            <span className="flex-shrink-0">
                                <img
                                    src={logo}
                                    alt="Axent Brokers Logo"
                                    className={(isMobile ? 'h-20' : 'h-30')}
                                />
                            </span>
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    {!isMobile && (
                        <>
                            <nav className="hidden md:flex space-x-8">
                                {navLinks.map((link) => (
                                    <NavLink key={link.path} to={link.path} external={link.external}>
                                        {link.name}
                                    </NavLink>
                                ))}
                            </nav>
                            <div className="hidden md:flex items-center">
                                {/* <a href="https://online.axentbrokers.com" target="_blank" rel="noopener noreferrer">
                                    <Button className="bg-white text-primary hover:bg-neutral-100 cursor-pointer">Login</Button>
                                </a>
                                <a href="https://online.axentbrokers.com/system/agent-register.aspx" target="_blank" rel="noopener noreferrer">
                                    <Button className="bg-white text-primary hover:bg-neutral-100 cursor-pointer">Register</Button>
                                </a> */}
                            </div>
                        </>
                    )}

                    {/* Mobile Menu Button */}
                    {isMobile && (
                        <button
                            type="button"
                            className="inline-flex items-center justify-center p-2 rounded-md text-neutral-800 hover:text-primary focus:outline-none"
                            onClick={toggleMenu}
                        >
                            {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                        </button>
                    )}
                </div>
            </div>

            {/* Mobile Menu */}
            {isMobile && (
                <div className={`md:hidden bg-white border-t ${isOpen ? "block" : "hidden"}`}>
                    <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                        {navLinks.map((link) =>
                            link.external ? (
                                <a
                                    key={link.path}
                                    href={link.path}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={closeMenu}
                                    className="block px-3 py-2 rounded-md text-base font-medium text-neutral-800 hover:text-primary hover:bg-axent cursor-pointer"
                                >
                                    {link.name}
                                </a>
                            ) : (
                                    <Link key={link.path} href={link.path} onClick={closeMenu}>
                                    <span
                                        className="block px-3 py-2 rounded-md text-base font-medium text-neutral-800 hover:text-primary hover:bg-axent cursor-pointer"
                                    >
                                        {link.name}
                                    </span>
                                </Link>
                            )
                        )}
                    </div>
                </div>
            )}
        </header>
    );
};

export default Navbar;
